<template>
  <div class="space-y-4">
    <div class="bg-white px-16 py-8">
      <Search @search="search"></Search>
    </div>
    <!-- <div class="bg-white px-16 py-4">
      <FlightList :items="items" v-if="show"></FlightList>
    </div> -->

    <div>
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="5"
        @current-change="handleCurrentChange" :current-page.sync="currentPage" v-if="total"
        :hide-on-single-page="true"></el-pagination>
      <img :src="require(`@/assets/image/暂无数据.png`)" class="m-auto" v-else />
    </div>
  </div>
</template>
<script>
import Search from "@/components/flight/search.vue";
import { ref } from "@vue/composition-api";
export default {
  components: { Search,  },
  props: { q: Object },
  setup(props, ctx) {
    const thatVuex = ctx.root.$store.state.receiving;
    const show = ref(true);
    const total = ref();
    const items = ref([]);
    const currentPage = ref(1);
    const getFlightList = async (page) => {
      const query = {
        area: thatVuex.localId,
        size: 5,
        page: page,
        q__date: thatVuex.localTime,
      };
      const res = await ctx.root.$callapi("getFlightList", query);
      return res.data;
    };
    getFlightList(1).then((res) => {
      items.value = res.items;
      total.value = res.total;
    });
    const search = async (form) => {
      currentPage.value = 1;
      getFlightList(1).then((res) => {
        items.value = res.items;
        total.value = res.total;
        show.value = false;
        ctx.root.$nextTick(() => {
          show.value = true;
        });
      });
    };
    //翻页
    const handleCurrentChange = async (val) => {
      getFlightList(val).then((res) => {
        items.value = res.items;
      });
    };
    return { search, items, show, total, handleCurrentChange, currentPage };
  },
};
</script>
<style lang="scss">

@import "@/style/theme.scss";

</style>
